import { isArrayEmpty } from '@kamernet/utilities/Array/isArrayEmpty';

import { ListingsSearchSideFilters } from '../types';

interface Options {
  isMDUp: boolean;
}

const blankFilterCheckers: Record<
  keyof ListingsSearchSideFilters,
  (v: ListingsSearchSideFilters, o: Options) => boolean
> = {
  availabilityPeriods: v => {
    return isArrayEmpty(v.availabilityPeriods);
  },
  availableFrom: v => {
    return !v.availableFrom;
  },
  furnishings: v => {
    return isArrayEmpty(v.furnishings);
  },
  hasInternet: v => {
    return !v.hasInternet;
  },
  isBathroomPrivate: v => {
    return !v.isBathroomPrivate;
  },
  isKitchenPrivate: v => {
    return !v.isKitchenPrivate;
  },
  isPetsInsideAllowed: v => {
    return !v.isPetsInsideAllowed;
  },
  isSmokingInsideAllowed: v => {
    return !v.isSmokingInsideAllowed;
  },
  isToiletPrivate: v => {
    return !v.isToiletPrivate;
  },
  searchCategories: (v, o) => {
    return o.isMDUp ? true : isArrayEmpty(v.searchCategories);
  },
  ownerTypes: v => {
    return isArrayEmpty(v.ownerTypes);
  },
  roommateGenders: v => {
    return isArrayEmpty(v.roommateGenders);
  },
  roommateNumberMax: v => {
    return !v.roommateNumberMax;
  },
  suitableForAge: v => {
    return !v.suitableForAge;
  },
  suitableForGenders: v => {
    return isArrayEmpty(v.suitableForGenders);
  },
  suitableForNumberOfPersons: v => {
    return !v.suitableForNumberOfPersons;
  },
  suitableForWorkStatuses: v => {
    return isArrayEmpty(v.suitableForWorkStatuses);
  },
  radius: (v, o) => {
    return o.isMDUp ? true : !v.radius;
  },
  maxRent: (v, o) => {
    return o.isMDUp ? true : !v.maxRent;
  },
  minSize: (v, o) => {
    return o.isMDUp ? true : !v.minSize;
  },
};

export function getListingsSearchSideFiltersCount(
  sideFilters: ListingsSearchSideFilters,
  options: Options,
): number {
  let count = 0;

  for (const blankFilterChecker of Object.values(blankFilterCheckers)) {
    if (!blankFilterChecker(sideFilters, options)) {
      count += 1;
    }
  }

  return count;
}
